<template>
    <div>
        <a :href="url">
            <img alt="" src="/svg/invoice.svg"/>
            <p class="mt-1 text-center">{{ text.toLowerCase() }}</p>
        </a>
    </div>
</template>

<script>
export default {
    props: ["text", "url"],
};
</script>

<style scoped>
p {
    -webkit-box-orient: vertical;
    color: black;
    display: -webkit-box;
    font-size: .7em;
    font-weight: 500;
    -webkit-line-clamp: 2; /* number of lines to show */
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
}

img {
    display: block;
    margin: auto;
    width: 50%;
    max-width: 25px;
}

.last-invoice-doc {
    img {
        max-width: 20px;
    }

    p {
        font-size: .7em;
    }
}

@media screen and (max-width: 1280px) {
    p {
        font-size: 0.8em;
    }
}
</style>
